import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      Designed by
      <a href="https://iampawan31.github.io/" rel="noreferrer" target="_blank">
        Pawan Kumar
      </a>
    </div>
  );
};

export default Footer;
